import { useCallback, useEffect, useState } from 'react'
import axios from 'axios'

import DownloadProgress from './DownloadProgress'
import MultipleFoldersDownloadList from './MultipleFoldersDownloadList'
import SingleFolderDownloadList from './SingleFolderDownloadList'

import { useKeyToken } from '../../common/hooks'
import { Container, Error, Message } from '../../common/primitives'

const LIFE_CYCLE = {
  LOADED: 'LOADED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  ERROR: 'ERROR',
}

const Downloader = () => {
  const { key, token } = useKeyToken()

  const [error, setError] = useState('')
  const [lifeCycle, setLifeCycle] = useState(LIFE_CYCLE.LOADED)
  const [files, setFiles] = useState([])
  const [fileMap, setFileMap] = useState(null)
  const [referenceKey, setReferenceKey] = useState('')

  const handleFinish = useCallback(
    (responseBody) => {
      setLifeCycle(LIFE_CYCLE.COMPLETED)

      if (responseBody.files && responseBody.files.length > 0) {
        setFiles(responseBody.files)
        setReferenceKey(responseBody.referenceKey)
      } else if (responseBody.fileMap) {
        if (Object.keys(responseBody.fileMap).length === 1) {
          const refKey = Object.keys(responseBody.fileMap)[0]
          setFiles(responseBody.fileMap[refKey])
          setReferenceKey(refKey)
        } else {
          setFileMap(responseBody.fileMap)
        }
      }
    },
    [setFiles, setLifeCycle, setReferenceKey]
  )

  const handleError = useCallback(
    (error) => {
      setLifeCycle(LIFE_CYCLE.ERROR)
      setError(error)
    },
    [setLifeCycle, setError]
  )

  const retrieveFiles = useCallback(() => {
    axios({
      method: 'GET',
      url: '/api/download',
      headers: {
        'X-Key': key,
        'X-Token': token,
      },
    })
      .then((res) => handleFinish(res.data))
      .catch((error) => {
        handleError(error)
        console.error(error)
      })

    setLifeCycle(LIFE_CYCLE.IN_PROGRESS)
  }, [key, token, handleError, handleFinish, setLifeCycle])

  useEffect(retrieveFiles, [retrieveFiles])

  return key ? (
    <>
      {(lifeCycle === LIFE_CYCLE.LOADED ||
        lifeCycle === LIFE_CYCLE.IN_PROGRESS) && <DownloadProgress />}
      {lifeCycle === LIFE_CYCLE.COMPLETED ? (
        fileMap ? (
          <>
            <MultipleFoldersDownloadList fileMap={fileMap} />
          </>
        ) : (
          <>
            <Message>Model reference: {referenceKey}</Message>
            <Container>
              <SingleFolderDownloadList
                files={files}
                referenceKey={referenceKey}
              />
            </Container>
          </>
        )
      ) : null}
      {lifeCycle === LIFE_CYCLE.ERROR && <Error error={error} />}
    </>
  ) : (
    <Error message="We're expecting a download URL. Please try again or contact Awa for help." />
  )
}

export default Downloader
